import L from 'leaflet';
import { isEmpty } from 'lodash';

const VISUALIZER_STYLE = {
  color: '#f0ad4e',
  weight: 5,
  opacity: 0.65
};

const SYNCHRONIZER_STYLE = {
  color: '#3388ff',
  opacity: 1
};

/**
 * Draws the video covered surface in the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object} arg.track - The video covered surface.
 * @param {?object} arg.trackLayer - The geoJSON layer where the covered surface will be painted.
 * @param {?object} [arg.onClickFunction] - The function to run when clicking on the track.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @param {boolean} [arg.isSynchronizer=false] - Flag to determine if we are doing an update.
 * @returns {object} The leaflet layer where the covered surface is painted.
 */
const drawVideoTrack = ({
  leafletMap,
  track,
  trackLayer,
  onClickFunction = () => {},
  isSynchronizer = false,
  isUpdate = false
}) => {
  let newTrackLayerContainer = '';
  if (!isUpdate) {
    newTrackLayerContainer = L.geoJSON().addTo(leafletMap);
  } else {
    newTrackLayerContainer = trackLayer;
    newTrackLayerContainer.clearLayers();
  }

  let trackStyle = {};
  if (!isSynchronizer) {
    trackStyle = VISUALIZER_STYLE;
  } else {
    trackStyle = SYNCHRONIZER_STYLE;
  }

  if (!isEmpty(track)) {
    const myTrackLayer = L.geoJSON(track, {
      style: trackStyle,
      onEachFeature: (feature, layer) => {
        layer.on('click', event => onClickFunction(event.latlng));
      }
    });
    newTrackLayerContainer.addLayer(myTrackLayer.getLayers()[0]);
  }
  return newTrackLayerContainer;
};
export default drawVideoTrack;
